import * as React from 'react';
import OCButton from '@cx-web/components/primitives/button';
import Icon from '@cx-web/components/primitives/icon';

import { useBetslipContext } from '~/providers/betslip-context';
// providers
import { useServicesContext } from '~/providers/services-context';
// services
import { TRACKING_ACTIONS, TRACKING_CATEGORIES, TRACKING_EVENTS } from '~/services/actions/tracking-actions';

// hooks
// styles
import styles from '../style/betslip.module.css';

const ButtonSection = () => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);

  const { labelActions, trackingActions } = useServicesContext();
  const { count: numberOfBets, handleClearBetslip, handleClickoutToPlaceBet, selectedBookie } = useBetslipContext();

  if (!mounted) return null;

  if (numberOfBets === 0) {
    return null;
  }

  return (
    <div className={styles.buttonSection}>
      <OCButton className={styles.button} onClick={handleClearBetslip} type="primary">
        {labelActions.get('DELETE_ALL')}
      </OCButton>
      <OCButton
        className={styles.button}
        onClick={() => {
          trackingActions.eventTracking({
            event: TRACKING_EVENTS.BET_ON_BOOKMAKER_SITE,
            eventCategory: TRACKING_CATEGORIES.BETTING,
            eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BET_ON_BOOKMAKER_SITE],
            eventLabel: selectedBookie?.bookmakerCode
          });
          handleClickoutToPlaceBet();
        }}
        type="secondary">

        <Icon height={16} icon="Clickout" width={16} />
        {labelActions.get('BET_ON_BOOKMAKER_WEBSITE')}
      </OCButton>
    </div>);

};

export default ButtonSection;